// Picked up from fraction
export function getDomain(host: string): string {
  if (host.length === 0) {
    return "";
  }

  if (host === "localhost") {
    return host;
  }

  const hostParts = host.split(".").reverse();
  if (hostParts.length >= 3) {
    const tldReg = /^(com|edu|gov|net|mil|org|nom|co|name|info|biz|uk|is|ca)$/i;
    if (hostParts[1].match(tldReg) && hostParts[0].match(tldReg)) {
      return `${hostParts[2]}.${hostParts[1]}.${hostParts[0]}`;
    }
  }
  return `${hostParts[1]}.${hostParts[0]}`;
}

export function getUrlPath(urlStr: string) {
  try {
    const url = new URL(urlStr);
    return url.pathname;
  } catch {
    return urlStr;
  }
}
